// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"b81a988e6ce4663cec80","966":"690378fd369af3b23308"}[chunkId] + ".js";
};